<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-26 09:58:36
 * @FilePath: 
 * @Description: 注册微会员验证手机号
-->
<template>
  <div class="full_page register_page">
    <div class="store_logo_con">
      <img :src="logoImgUrl" alt="" />
    </div>
    <div class="register_form_con">
      <van-form @submit="onSubmit">
        <van-field
          v-model="formData.MobilePhone"
          type="tel"
          name="MobilePhone"
          maxlength="11"
          label="手机号"
          placeholder="请输入手机号"
          :error="false"
          :rules="[{ required: true, message: '请输入手机号' }]"
        >
          <template #button>
            <g-send-code
              :disabled.sync="codeDiabled"
              :phone="formData.MobilePhone"
              :click="handleGetCode"
              color="var(--tc)"
              ref="sendRef"
            ></g-send-code>
            <!-- <van-button size="small" type="primary" @click="handleGetCode">获取验证码</van-button> -->
          </template>
        </van-field>
        <van-field
          v-model="formData.SmsCode"
          type="number"
          maxlength="6"
          name="SmsCode"
          label="验证码"
          placeholder="请输入验证码"
          :error="false"
          :rules="[{ required: true, message: '请输入验证码' }]"
        />
        <div style="margin: 16px">
          <van-button
            block
            color="var(--tc)"
            native-type="submit"
            :loading="isSubmiting"
            loading-text="提交中..."
            >提交</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { validMiniMember } from "@/api/member";
export default {
  name: "ValidMember",
  props: {},
  data() {
    return {
      logoImgUrl: "",
      codeDiabled: false,
      formData: {
        MobilePhone: "",
        SmsCode: "",
      },
      isSubmiting: false,
    };
  },
  components: {},
  watch: {
    "formData.MobilePhone"(val) {
      if (val.length === 11) {
        this.codeDiabled = false;
      } else {
        this.codeDiabled = true;
      }
    },
  },
  created() {},
  mounted() {
    const vpnInfo = this.$store.state.vpnInfo;
    console.log(this.$store);
    const imgArr = vpnInfo.Claims;
    if (imgArr instanceof Array && imgArr.length > 0) {
      const imgItem = imgArr.find((subItem) => subItem.TypeId === 2);
      if (imgItem) {
        this.logoImgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
      }
    }
  },
  methods: {
    handleGetCode() {
      $http(
        "wechath5/zh-cn/v1/member/sendsmscode?phone=" +
          this.formData.MobilePhone
      ).then((res) => {
        this.$toast("发送验证码成功");
        this.$refs.sendRef.activeCode();
      });
    },
    onSubmit(values) {
      console.log("submit", values);
      this.isSubmiting = true;
      validMiniMember(values)
        .then((res) => {
          this.isSubmiting = false;
          this.$router.push({
            name: "RegisteredMember",
            query: { phone: this.formData.MobilePhone },
          });
        })
        .catch(() => {
          this.isSubmiting = false;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.register_page {
  background: linear-gradient(180deg, #f4f3f0 0%, #fff 100%);
  padding-top: 1px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .store_logo_con {
    margin: 290px 135px 0;
    img {
      width: 100%;
    }
  }
  .register_form_con {
    padding: 0 30px 300px;
  }
}
</style>
